import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NumbersGridComponent } from './numbers-grid.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NumbersGridComponent],
  exports: [NumbersGridComponent]
})
export class NumbersGridModule {
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/numbers-grid/numbers-grid.module.ts